<header>
    <div class="ng-row height-100"align-item-center justify-content-between>
        <!-- <div class="ng-col hide-on-mob" col-1>
            
        </div> -->

        <div class="ng-col" col-3 col-sm-4>
            
        </div>
        <div class="ng-col text-align-center" col-6 col-sm-4>
            <img src="~/../assets/images/logo.png" alt="" width="180" class="mt-10">
        </div>
            
        <div class="ng-col" col-3 col-sm-4>
            <div class="ng-row" align-item-center justify-content-right *ngIf="this.logout" (click)="logoutbtn()">
                <div class="ng-col" col-auto>
                    <i class="icon-logout"></i>
                </div>
                <div class="ng-col pr-15" col-auto>
                    <div class="font-700 font-14 color-e76 link">
                        {{"Logout" | translate}}
                    </div>
                </div>
            </div>
        </div>


        <!-- <div class="ng-col p-l-r text-align-right not-apply top-bar" col-1 col-sm-12 order-on-1>
            <a href="mailto:Dibrda.inquiry@dibpak.com"><i class="icon-information"></i></a>
        </div> -->
    </div>
    <div class="header-boder">
        
    </div>
</header>